/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetDeletedFilesMetadataMutationResponse } from "../../models/filesController/FilesControllerGetDeletedFilesMetadata";

function getFilesControllerGetDeletedFilesMetadataUrl() {
  const res = { method: 'POST', url: `/api/v1/files/deleted-metadata` as const }  
  return res
}

/**
 * @description Returns deletion metadata (fileName, deletedAt) for files that have been soft-deleted.
 * @summary Get metadata for deleted files by file IDs
 * {@link /api/v1/files/deleted-metadata}
 */
export async function filesControllerGetDeletedFilesMetadata(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerGetDeletedFilesMetadataMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getFilesControllerGetDeletedFilesMetadataUrl().url.toString(), ... requestConfig })  
  return res.data
}